import { render, staticRenderFns } from "./HomeCollections.vue?vue&type=template&id=46c8e913&scoped=true&"
import script from "./HomeCollections.vue?vue&type=script&lang=js&"
export * from "./HomeCollections.vue?vue&type=script&lang=js&"
import style0 from "./HomeCollections.vue?vue&type=style&index=0&id=46c8e913&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c8e913",
  null
  
)

export default component.exports